<template>
    <div class="popup popup-cart popup__sizes" :class="{ 'popup-show': show }">
        <div class="popup__wrapper">
            <div class="popup__content">
                <div class="cart">
                    <div class="cart__top-wrapper">
                        <div class="cart__top top-cart">
                            <div class="top-cart__title"></div>
                            <button type="button" class="popup__close _icon-close" @click="closePopup"></button>
                        </div>
                        <div class="cart__top top-cart">
                            <NuxtImg class="w-full object-contain" :src="kolyeSizes" alt="kolye_sizes.PNG" v-if="category == '34'" />
                            <NuxtImg class="w-full object-contain" :src="brasletSizes" alt="braslet_sizes.webp" v-if="category == '19'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// Константы для путей к изображениям
const kolyeSizes = new URL("@/assets/img/sizes/kolye_sizes.png", import.meta.url).href;
const brasletSizes = new URL("@/assets/img/sizes/braslet_sizes.webp", import.meta.url).href;

defineProps({
    show: {
        type: Boolean,
        required: true,
    },
    category: {
        type: [String, Number],
        required: true,
    },
});

const emit = defineEmits(["update:show"]);

const closePopup = () => {
    emit("update:show", false);
};
</script>

<style scope>
.popup__sizes .cart {
    padding: 0 !important;
}
.popup__sizes .popup__wrapper {
    height: auto;
}
</style>
